// 实现简繁体转换的工具类
// import * as OpenCC from 'opencc-js';
import { Converter } from 'opencc-js'

// 简体转繁体
const toTraditionalConverter  = Converter({ from: 'cn', to: 'tw' })
// 繁体转简体
const toSimplifiedConverter = Converter({ from: 'tw', to: 'cn' })

 /**
 * 转换HTML中的文本节点为繁体
 * @param {string} html - 原始HTML字符串
 * @param {boolean} debug - 是否输出调试信息
 * @returns {string} 转换后的HTML字符串
 */
export function convertHtmlToTraditional(html, debug = false) {
  return convertHtml(html, toTraditionalConverter, '繁体', debug)
}

/**
 * 转换HTML中的文本节点为简体
 * @param {string} html - 原始HTML字符串
 * @param {boolean} debug - 是否输出调试信息
 * @returns {string} 转换后的HTML字符串
 */
export function convertHtmlToSimplified(html, debug = false) {
  return convertHtml(html, toSimplifiedConverter, '简体', debug)
}

/**
 * 通用的HTML转换函数
 * @param {string} html - HTML字符串
 * @param {function} converter - 转换器函数
 * @param {string} direction - 转换方向描述
 * @param {boolean} debug - 是否调试模式
 * @returns {string} 转换后的HTML
 */
function convertHtml(html, converter, direction, debug = false) {
  if (debug) console.group(`HTML转${direction}过程`)
  
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  
  if (debug) {
    console.log(`原始HTML输入:`, html)
    console.log(`解析后的DOM结构:`, tempDiv.cloneNode(true))
  }

  const walk = (node, depth = 0) => {
    const indent = '  '.repeat(depth)
    
    if (node.nodeType === Node.TEXT_NODE) {
      const original = node.nodeValue
      const converted = converter(original)
      
      if (debug) {
        console.log(`${indent}文本节点:`, {
          '原始内容': original,
          '转换后内容': converted,
          '变化': original !== converted ? '已修改' : '未变化'
        })
      }
      
      node.nodeValue = converted
    } 
    else if (node.nodeType === Node.ELEMENT_NODE) {
      if (debug) console.log(`${indent}元素节点: <${node.tagName.toLowerCase()}>`)
      
      Array.from(node.childNodes).forEach(child => {
        walk(child, depth + 1)
      })
    }
  }
  
  walk(tempDiv)
  
  const result = tempDiv.innerHTML
  if (debug) {
    console.log(`最终${direction}转换结果:`, result)
    console.groupEnd()
  }
  
  return result
}
